<div class="modal-header">
    <h5 class="modal-title">{{ employee.firstName }} {{ employee.lastName }} - Wage Info</h5>
</div>
<form name="form">
    <div class="modal-body">
        <h6>Latest by reason</h6>
        @if (wageChanges.length === 0) {
            <p class="text-muted">No tagged pay-change reasons.</p>
        } @else {
            <table class="wage-table">
                <thead>
                    <tr>
                        <th>Reason</th>
                        <th>Date</th>
                        <th>Percent</th>
                        <th>Wage</th>
                    </tr>
                </thead>
                <tbody>
                    @for (change of wageChanges; track change.reasonCode + change.effectiveDateText) {
                        <tr>
                            <td>{{ change.reasonCode }}</td>
                            <td>{{ change.effectiveDateText }}</td>
                            <td>{{ change.pctIncrease | percent: '1.2-2' }}</td>
                            <td>
                                @if (change.newSalary != null) {
                                    {{ change.newSalary | currency: 'USD' : 'symbol' : '1.2-2' }}
                                } @else {
                                    —
                                }
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        }

        <h6 class="history-heading">Salary history</h6>
        @if (wageHistory.length === 0) {
            <p class="text-muted">No salary history.</p>
        } @else {
            <div class="history-scroll">
                <table class="wage-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Reason</th>
                            <th>Percent</th>
                            <th>Wage</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of wageHistory; track row.effectiveDateText + (row.reasonCode ?? '') + $index) {
                            <tr>
                                <td>{{ row.effectiveDateText }}</td>
                                <td>{{ row.reasonCode }}</td>
                                <td>{{ row.pctIncrease | percent: '1.2-2' }}</td>
                                <td>
                                    @if (row.newSalary != null) {
                                        {{ row.newSalary | currency: 'USD' : 'symbol' : '1.2-2' }}
                                    } @else {
                                        —
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>
    </div>
</form>
